import React from "react";
import classNames from "classnames";

import FormGroup from "./FormGroup";
import FormLabel from "./FormLabel";
import FormControl from "./FormControl";
import FormFeedback from "./FormFeedback";

const Form = ({ className, children, ...props }) => {
  const classes = classNames("form", className);

  return (
    <form {...props} className={classes}>
      {children}
    </form>
  );
};

Form.Group = FormGroup;
Form.Label = FormLabel;
Form.Control = FormControl;
Form.Feedback = FormFeedback;

export default Form;
